export default {"src":"/_next/static/media/CirclesFour.218d5459.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};